<template>
    <div class="header_box">
        <!-- <div>Admin</div> -->
        <el-popover placement="top-start" width="50" trigger="hover">
            <div class="box" @click="exit()">
                <i class="el-icon-remove"></i>
                退出登录

            </div>

            <el-button slot="reference" type="text" class="btn">Admin</el-button>
        </el-popover>
    </div>
</template>

<script>
    import {
        loginOut
    } from '../api/api'
    import local from '../utils/local'
    export default {
        data() {
            return {

            };
        },
        methods: {
            exit() {
                let id = local.get('admin_id')
                loginOut(id).then(res => {
                    console.log(res)
                    if (res.data.status == 200) {
                        local.remove("admin_id");
                        this.$message({
                            type: 'success',
                            message: '退出成功'
                        })
                        this.$router.push('/login')

                    }
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .header_box {
        width: 100%;
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        box-shadow: 0 8px 10px -6px #d5d5d5;
        padding: 0;
        .box {
            padding: 10px;

            .btn2 {
                margin-left: 10px;
                color: #333 !important;

            }

        }

        .btn {
            margin-right: 50px;
            color: #333;
        }

    }
</style>